import '.aw{position:relative;}.ssr-plugin'
import '.ia{width:64px;}.ssr-plugin'
import '.ib{height:64px;}.ssr-plugin'
import '.am{flex-shrink:0;}.ssr-plugin'
import '.b1{position:absolute;}.ssr-plugin'
import '.ic{bottom:-4px;}.ssr-plugin'
import '.ej{right:-4px;}.ssr-plugin'
import '.ff{border-radius:50%;}.ssr-plugin'
import '.id{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ag{overflow:hidden;}.ssr-plugin'
import '.ie{width:32px;}.ssr-plugin'
import '.if{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="aw ia ib am"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b1 ic ej ff id ag ie if"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
